import { number, object } from '@gogame/schemas';

import { CONCEPT_ID, CREATIVE_ID } from 'scenes/Gallery/GalleryPage/constants';

export const validationSchema = object({
  [CONCEPT_ID]: number().required('Concept is required'),
  [CREATIVE_ID]: number().required('Creative is required'),
});
